
export default class NoteService {
  private postCorsJSON(method: string, params: object) {
    if (typeof params !== 'object') {
      throw new Error('params should be obj' + params);
    }

    return new Promise((resolve, reject) => {
      const request = new XMLHttpRequest();

      request.open('POST', window.ApplicationPath + '/WebServices/WebService.asmx/' + method, true);
      request.setRequestHeader('Accept', 'application/json');
      request.setRequestHeader('Content-Type', 'application/json; charset=utf-8');
      request.withCredentials = true;
      request.onload = () => {
        if (request.status >= 200 && request.status < 400) {
          // Success!
          const data = JSON.parse(request.responseText);
          if (data.d.error) {
            reject();
          } else {
            resolve(data.d);
          }
        } else {
          reject();
        }
      };

      request.onerror = () => {
        reject();
      };

      request.send(JSON.stringify(params));
    });

  }
  public AddNote(payload: {OrderId: number, Description: string }) {
    return this.postCorsJSON('EditNote', payload);
  }
  public DeleteNote(payload: {OrderId: number}) {
    return this.postCorsJSON('DeleteNote', payload);
  }
  public EditNote(payload: {OrderId: number, Description: string }) {
    return this.postCorsJSON('EditNote', payload);
  }
  public LoadNotes(payload: {ids: number[] }) {
    return this.postCorsJSON('GetNotes', payload);
  }
}
